import About from "./About";
import Contact from "./Contact";
import HeroSection from "./HeroSection";
import ParallaxEffect from "./ParallaxEffect";
import Service from "./Service";
import SwiperEffect from "./Swiper";

//
export default function Landing() {
  return (
    <>
    <SwiperEffect/>
      <HeroSection/>
      <About/>
      <Service/>
      <ParallaxEffect/>
      <Contact/>
    </>
  );
}
